<div [formGroup]="formularzUszkodzenia">
    <label class="c-label">
        <span [class.text-danger]="WYSOKOSC.errors && (WYSOKOSC.touched || WYSOKOSC.dirty)" class="c-label__title"> Wysokość (m)</span>
        <input id='wysokosc' formControlName="wysokosc" type="number" class="c-input" value="" title="">
        <span *ngIf="WYSOKOSC.errors && (WYSOKOSC.touched || WYSOKOSC.dirty)" class="c-label__title text-danger u-margin-right-tiny">
            Dane powinny być z zakresu od {{minimalnaWysokosc?.toFixed(2) | number:'':language }} do {{maksymalnaWysokosc?.toFixed(2) | number:'':language}}
        </span>
    </label>
</div>
